import { useTranslation } from 'react-i18next';

import { nomeGiocatore } from '@/lib/myBoards/riga';
import type { OriginPlayer } from '@/types/myBoards';

/**
 * Il nome di un giocatore d'origine scritto nella lingua: «Tu» per chi guarda, il nome, o «giocatore non piu' presente»
 * (ADR-0191 §3: si salvano gli id, non i nomi; un account cancellato svuota il suo id). Il `logtoSub` non c'e' mai.
 */
export function useNomeGiocatore(mioId: string | null): (p: OriginPlayer) => string {
  const { t } = useTranslation('backgammon');
  return (p) => {
    const n = nomeGiocatore(p, mioId);
    return n.kind === 'me' ? t('myBoards.row.you') : n.kind === 'gone' ? t('myBoards.row.gone') : n.name;
  };
}
